var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c("div", { staticClass: "ri-header" }, [
            _c("span", { staticClass: "ri-title" }, [
              _vm._v(_vm._s(_vm.reportName) + " - 数据项"),
            ]),
            _c(
              "div",
              { staticClass: "float-right" },
              [
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-right": "8px" },
                    on: { click: _vm.goBack },
                  },
                  [_vm._v("返回")]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", icon: "plus" },
                    on: {
                      click: function ($event) {
                        return _vm.handleAdd()
                      },
                    },
                  },
                  [_vm._v("添加项目")]
                ),
              ],
              1
            ),
          ]),
          _c("a-table", {
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.rows,
              pagination: false,
              loading: _vm.loading,
              scroll: _vm.tableScroll,
            },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _vm.canOperate(record)
                        ? [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddChild(record)
                                  },
                                },
                              },
                              [_vm._v("添加子级")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(record)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            record.is_group !== "1"
                              ? [
                                  _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  }),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFormula(record)
                                        },
                                      },
                                    },
                                    [_vm._v("公式")]
                                  ),
                                ]
                              : _vm._e(),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(record)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        : _c("span", [_vm._v("-")]),
                    ],
                    2
                  )
                },
              },
              {
                key: "name",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        paddingLeft: (record.level || 0) * 15 + 8 + "px",
                        fontWeight: record.bold === "1" ? 600 : 400,
                      },
                    },
                    [_vm._v(_vm._s(record.item_name))]
                  )
                },
              },
              {
                key: "source",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(_vm.sourceText(record))),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.itemForm.id ? "编辑项目" : "添加项目",
            visible: _vm.itemVisible,
            confirmLoading: _vm.itemSaving,
            maskClosable: false,
            okText: "保存",
            cancelText: "取消",
            width: "640px",
          },
          on: {
            ok: _vm.saveItem,
            cancel: function ($event) {
              _vm.itemVisible = false
            },
          },
        },
        [
          _c(
            "a-form",
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "项目名称",
                    required: "",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入项目名称" },
                    model: {
                      value: _vm.itemForm.itemName,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "itemName", $$v)
                      },
                      expression: "itemForm.itemName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "归类项",
                  },
                },
                [
                  _c(
                    "a-checkbox",
                    {
                      on: { change: _vm.onGroupChange },
                      model: {
                        value: _vm.itemForm.isGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemForm, "isGroup", $$v)
                        },
                        expression: "itemForm.isGroup",
                      },
                    },
                    [_vm._v("归类项（纯标题行，不取数）")]
                  ),
                  _vm.itemForm.isGroup
                    ? _c(
                        "div",
                        { staticStyle: { color: "#999", "font-size": "12px" } },
                        [_vm._v("归类项不需要设置行号和公式")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "上级项目",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "无（作为顶级项目）",
                        allowClear: "",
                      },
                      model: {
                        value: _vm.itemForm.parentId,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemForm, "parentId", $$v)
                        },
                        expression: "itemForm.parentId",
                      },
                    },
                    _vm._l(_vm.parentOptions, function (p) {
                      return _c(
                        "a-select-option",
                        { key: p.id, attrs: { value: p.id } },
                        [
                          _c(
                            "span",
                            {
                              style: {
                                display: "inline-block",
                                paddingLeft: (p.level || 0) * 15 + "px",
                              },
                            },
                            [_vm._v(_vm._s(p.item_name))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "行次",
                  },
                },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 1, disabled: _vm.itemForm.isGroup },
                    model: {
                      value: _vm.itemForm.rowNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "rowNo", $$v)
                      },
                      expression: "itemForm.rowNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "取数来源",
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { disabled: _vm.itemForm.isGroup },
                      model: {
                        value: _vm.itemForm.sourceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.itemForm, "sourceType", $$v)
                        },
                        expression: "itemForm.sourceType",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: "outer" } }, [
                        _vm._v("表外公式"),
                      ]),
                      _c("a-radio", { attrs: { value: "inner" } }, [
                        _vm._v("表内公式"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.itemForm.isGroup && _vm.itemForm.sourceType === "inner"
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "表内公式",
                        required: "",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "行次加减式，如 1-2-3+5" },
                        model: {
                          value: _vm.itemForm.innerFormula,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemForm, "innerFormula", $$v)
                          },
                          expression: "itemForm.innerFormula",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.routeType === "balance"
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "类别",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: {
                            placeholder: "请选择类别",
                            allowClear: "",
                            disabled: _vm.itemForm.isGroup,
                          },
                          model: {
                            value: _vm.itemForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemForm, "category", $$v)
                            },
                            expression: "itemForm.category",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "资产" } }, [
                            _vm._v("资产"),
                          ]),
                          _c("a-select-option", { attrs: { value: "负债" } }, [
                            _vm._v("负债"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "所有者权益" } },
                            [_vm._v("所有者权益")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "名称加粗",
                  },
                },
                [
                  _c("a-checkbox", {
                    model: {
                      value: _vm.itemForm.bold,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "bold", $$v)
                      },
                      expression: "itemForm.bold",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "是否折叠",
                  },
                },
                [
                  _c("a-checkbox", {
                    model: {
                      value: _vm.itemForm.folded,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "folded", $$v)
                      },
                      expression: "itemForm.folded",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "显示位置",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "如：左 / 右" },
                    model: {
                      value: _vm.itemForm.displayPos,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "displayPos", $$v)
                      },
                      expression: "itemForm.displayPos",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "排序",
                    required: "",
                  },
                },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0 },
                    model: {
                      value: _vm.itemForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.itemForm, "sort", $$v)
                      },
                      expression: "itemForm.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title:
              "编辑公式 - " +
              (_vm.formulaItem ? _vm.formulaItem.item_name : ""),
            visible: _vm.formulaVisible,
            maskClosable: false,
            footer: null,
            width: "720px",
          },
          on: {
            cancel: function ($event) {
              _vm.formulaVisible = false
            },
          },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.formulaLoading } },
            [
              _vm.formulaItem && _vm.formulaItem.source_type === "inner"
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "8px",
                          color: "#999",
                          "font-size": "12px",
                        },
                      },
                      [_vm._v("可用行次：" + _vm._s(_vm.availableRowNos))]
                    ),
                    _c("a-input", {
                      attrs: { placeholder: "行次加减式，如 1-2-3+5" },
                      model: {
                        value: _vm.innerFormulaValue,
                        callback: function ($$v) {
                          _vm.innerFormulaValue = $$v
                        },
                        expression: "innerFormulaValue",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "margin-top": "12px",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-right": "8px" },
                            on: {
                              click: function ($event) {
                                _vm.formulaVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.formulaSaving,
                            },
                            on: { click: _vm.saveInnerFormula },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm.formulaItem
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "margin-bottom": "12px",
                        },
                      },
                      [
                        _c(
                          "a-select",
                          {
                            staticStyle: { width: "280px" },
                            attrs: {
                              "show-search": "",
                              placeholder: "选择科目",
                              disabled:
                                _vm.newFormula.calcRule === "损益净额合计",
                              filterOption: _vm.filterSubjectOption,
                            },
                            model: {
                              value: _vm.newFormula.subjectCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormula, "subjectCode", $$v)
                              },
                              expression: "newFormula.subjectCode",
                            },
                          },
                          _vm._l(_vm.subjectOptions, function (o) {
                            return _c(
                              "a-select-option",
                              { key: o.code, attrs: { value: o.code } },
                              [_vm._v(_vm._s(o.label))]
                            )
                          }),
                          1
                        ),
                        _c(
                          "a-select",
                          {
                            staticStyle: {
                              width: "80px",
                              "margin-left": "8px",
                            },
                            model: {
                              value: _vm.newFormula.operator,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFormula, "operator", $$v)
                              },
                              expression: "newFormula.operator",
                            },
                          },
                          [
                            _c("a-select-option", { attrs: { value: "+" } }, [
                              _vm._v("+"),
                            ]),
                            _c("a-select-option", { attrs: { value: "-" } }, [
                              _vm._v("-"),
                            ]),
                          ],
                          1
                        ),
                        _vm.calcRules.length === 1
                          ? _c(
                              "span",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v("取数规则：" + _vm._s(_vm.calcRules[0]))]
                            )
                          : _c(
                              "a-select",
                              {
                                staticStyle: {
                                  width: "150px",
                                  "margin-left": "8px",
                                },
                                model: {
                                  value: _vm.newFormula.calcRule,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newFormula, "calcRule", $$v)
                                  },
                                  expression: "newFormula.calcRule",
                                },
                              },
                              _vm._l(_vm.calcRules, function (r) {
                                return _c(
                                  "a-select-option",
                                  { key: r, attrs: { value: r } },
                                  [_vm._v(_vm._s(r))]
                                )
                              }),
                              1
                            ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "12px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.addFormulaRow },
                          },
                          [_vm._v("添加")]
                        ),
                      ],
                      1
                    ),
                    _c("a-table", {
                      attrs: {
                        bordered: "",
                        size: "middle",
                        rowKey: "key",
                        columns: _vm.formulaColumns,
                        dataSource: _vm.formulaRows,
                        pagination: false,
                        loading: _vm.formulaLoading,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "subject",
                          fn: function (text, record) {
                            return _c("span", {}, [
                              _vm._v(
                                _vm._s(
                                  _vm.subjectDisplay(
                                    record.subject_code,
                                    record.calc_rule
                                  )
                                )
                              ),
                            ])
                          },
                        },
                        {
                          key: "fAction",
                          fn: function (text, record) {
                            return _c(
                              "span",
                              { staticStyle: { display: "block" } },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFormulaRow(record)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "margin-top": "12px",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-right": "8px" },
                            on: {
                              click: function ($event) {
                                _vm.formulaVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.formulaSaving,
                            },
                            on: { click: _vm.saveFormulas },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }